<template>
  <div id="app_content" class="public">
    <div class="section top fp-section fp-table active fp-completely">
      <div class="section-container">
        <div class="my-content">
          <div class="container align-items-center d-flex">
            <section id="contact-us " class="contact-us col-md-12">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="my-h1 mb-3">
                      {{ trans.get("b2b.footer.contact-us") }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <ValidationObserver v-slot="{ invalid }">
                      <form class="row" @submit.prevent="onSubmit">
                        <div class="form-group col-md-12">
                          <ValidationProvider
                              rules="min:5|max:40|required"
                              v-slot="{ errors }"
                          >
                            <label class="text-capitalize" for="nome">{{
                                trans.get("b2b.footer.name")
                              }}</label>
                            <input
                                type="text"
                                class="form-control"
                                :class="errors[0] ? 'invalid' : ''"
                                id="nominative_user"
                                v-model="contact_us.nominative_user"
                            />
                            <small>{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-6">
                          <ValidationProvider
                              rules="email|required"
                              v-slot="{ errors }"
                          >
                            <label for="email">{{
                                trans.get("b2b.footer.email")
                              }}</label>
                            <input
                                type="email"
                                class="form-control"
                                :class="errors[0] ? 'invalid' : ''"
                                id="email"
                                v-model="contact_us.email"
                            />
                            <small>{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>

                        <div class="form-group telefono col-md-6">
                          <ValidationProvider rules="" v-slot="{ errors }">
                            <label class="text-capitalize" for="telefono">{{
                                trans.get("b2b.footer.phone")
                              }}</label>
                            <input
                                type="phone"
                                class="form-control"
                                :class="errors[0] ? 'invalid' : ''"
                                id="phone"
                                v-model="contact_us.phone"
                            />
                            <small>{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-12">
                          <ValidationProvider
                              rules="min:5|max:50|required"
                              v-slot="{ errors }"
                          >
                            <label class="text-capitalize" for="object">{{
                                trans.get("b2b.footer.subject")
                              }}</label>
                            <input
                                type="text"
                                class="form-control"
                                :class="errors[0] ? 'invalid' : ''"
                                id="object_message"
                                v-model="contact_us.object_message"
                            />
                            <small>{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-12">
                          <ValidationProvider
                              rules="min:20|max:500|required"
                              v-slot="{ errors }"
                          >
                            <label class="text-capitalize" for="messaggio">{{
                                trans.get("b2b.footer.message")
                              }}</label>
                            <textarea
                                class="form-control"
                                :class="errors[0] ? 'invalid' : ''"
                                id="message"
                                rows="6"
                                v-model="contact_us.message"
                            ></textarea>
                            <small>{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>

                        <ValidationProvider rules="true" v-slot="{ errors }">
                          <div class="form-check col-md-12">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="contact_acceptance"
                                value="true"
                                id="acceptance"
                            />
                            <label class="form-check-label" for="acceptance">
                              {{ trans.get('public.contact.read') }}<a target=”_blank” :href="url('/privacy-policy')"><u>{{ trans.get('public.contact.privacy') }}</u>
                              </a>
                              {{ trans.get('public.contact.desc') }}
                            </label>
                            <small>{{ errors[0] }}</small>
                          </div>
                        </ValidationProvider>

                        <div class="col-md-12 invia-btn">
                          <button
                              type="submit"
                              class="link-ret green"
                              :disabled="invalid"
                              @click="contactSubmit()"
                          >
                            {{ trans.get("b2b.footer.send") }}
                          </button>
                          <button
                              type="submit"
                              v-if="invalid"
                              class="link-ret disabled"
                          >
                            {{ trans.get("b2b.footer.send") }}
                          </button>
                        </div>
                      </form>
                    </ValidationObserver>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="messaggio-successo" v-if="successo !== ''">
      {{ successo }}
    </div>
  </div>
</template>

<script>
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },

  data: function () {
    return {
      successo: "",
      contact_acceptance: false,
      contact_us: {
        nominative_user: "",
        email: "",
        phone: "",
        object_message: "",
        message: "",
      },
    };
  },

  created: function () {
  },

  mounted: function () {
  },

  computed: {},

  methods: {
    onSubmit() {
      // alert("Form has been submitted!");
    },

    contactSubmit() {
      axios({
        method: "post",
        url: window.location.origin + "/communications",
        params: {
          action: "contact-us",
          nominative_user: this.contact_us.nominative_user,
          email: this.contact_us.email,
          phone: this.contact_us.phone,
          object_message: this.contact_us.object_message,
          message: this.contact_us.message,
        },
      })
          .then((res) => {
            console.log(res.data);
            if (res.data.success) {
              this.success();
            }
          })
          .catch((error) => {
            this.error(error.response.data.message)
          });

      this.contact_us = {
        nominative_user: "",
        email: "",
        phone: "",
        object_message: "",
        message: "",
      };

      // console.log(this.contactReceived);
    },
    success() {
      this.successo = "Il tuo messaggio è stato recapitato.";
      setTimeout(() => {
        this.successo = "";
        window.location.replace(window.location.origin);
      }, 2500);
    },
    error(msg) {
      this.successo = msg;
      setTimeout(() => {
        this.successo = "";
        window.location.reload();
      }, 2500);
    },
  },
};
</script>

<style lang="scss" scoped>
/*
 * contenuto delle sezioni allineato togliendo l'ingombro
 * del menù
*/
.form-group {
  padding: 0;

  &.telefono {
    padding-left: 15px;
    @media (max-width: 576px) {
      padding-left: 0;
    }
  }
}

.invia-btn {
  padding: 0;
}

@media (max-width: 576px) {
  .container, .contact-us {
    padding-left: 0;
    padding-right: 0;
  }
  .contact-us {
    padding-bottom: 45px;
  }
}

.link-ret {
  margin: 20px 0;
  width: 80%;
}

#app_content {
  background-color: #25252a;
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }

  p {
    text-align: justify;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert;
  font-weight: normal;
}

.section .section-container {
  max-width: calc(100% - var(--public-menu-width));
  margin: 0 0 0 var(--public-menu-width);
}

.section.top {
  padding: 0;
}

.inner-section {
}

.inner-top {
  height: 25vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.inner-bottom {
  height: fit-content;
  padding: 2rem 0;
}

@media (min-width: 576px) {
  .inner-top {
    height: 50vh;
  }
  .inner-bottom {
    height: 50vh;
    padding: unset;
  }
}

@media screen and (max-width: 1220px) {
  .section .section-container {
    max-width: 95%;
    margin: auto;
  }
}

/*
 * payoff
*/
.payoff {
  font-size: 60px;
  font-weight: lighter;
}

@media screen and (max-width: 750px) {
  .payoff {
    font-size: 2.4em;
  }
}

@media screen and (max-width: 400px) {
  .payoff {
    font-size: 2em;
  }
}

.section.top,
.section.bgi {
  width: 100%;

  color: white;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: cover;
  background-position: initial;
}

.section.bgi {
  background-size: contain;
  height: 100vh;
}

.section-sub {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.std {
  width: 100%;
  height: 100vh;
  background-color: var(--black-2);
}

.section.top .content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.top .content h1 {
  font-size: 60px;
  font-weight: lighter;
}

#app-scroll
> div.section.top.fp-section.active.fp-table.fp-completely
> div
> div
> div
> div
> img {
  width: 420px;
  height: 130px;
}

.section.top .fp-tableCell {
  // width: calc(100vw - 250px);
  height: 100% !important;
  float: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.section.top {

  .section-container-center-mode {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .discover-button {
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .discover-text {
      display: inline-block;
      margin-bottom: 20px;
    }
  }
}

.section.std .content .text {
  color: white;
  width: 100%;
  max-width: 95%;
  width: 760px;
  margin: auto;
}

.section.std .content .text h1 {
  font-weight: 500;
}

.section.std .content .text p {
  margin: 0;
  font-weight: 300;
  color: var(--text-white);
}

.content-gallery {
  width: 100%;
  margin: auto;
  position: relative;
}

.content-gallery .slick-slider {
  margin-left: -180px;
}

.content-source-media {
  width: auto;
}

.content-source-media .source {
  width: inherit;
}

.content-source-media .source img {
  display: block;
  width: inherit;
  padding: 2em;
  transition: padding 0.2s 0.2s ease-in-out;
}

.slick-slide[aria-hidden="false"]:not(.slick-current) .source img {
  opacity: 0.4;
}

.slick-slide[aria-hidden="true"] .source img {
  opacity: 0.1;
}

.slick-slide.slick-current {
  z-index: 2;
  position: relative;
}

.slick-slide.slick-current .source img {
  padding: 0;
  opacity: 1;
}

.slick-prev::before,
.slick-next::before {
  content: "";
}

.btn-circle.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-circle.slick-prev {
  top: 110px;
  left: 70%;
}

.btn-circle.slick-next {
  bottom: 40px;
  left: 70%;
}

.btn-circle.arrow span {
  width: 48px;
  height: 22px;
  display: inline-block;
  position: absolute;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: 100% auto;
  background-position: center;
}

.btn-circle.slick-prev span {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

/* ---------------------------- */

.fp-tableCell {
  position: relative;
}

.section:not(.gallery) .content,
.section-sub .content {
  max-width: 760px;
  margin: auto;
  position: relative;
}

.section .wrapper-data {
  width: 100%;
  margin-top: 20px;
}

@media (min-width: 1200px) {
  .section.top .fp-tableCell {
    width: calc(100vw - 250px);
  }
}

.messaggio-successo {
  position: fixed;
  display: inline-block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 50px;
  background-color: var(--greenb2b);
  color: #000;
}

.form-group,
.mt-25px {
  margin-top: 25px;
}

button[disabled="disabled"] {
  display: none;
}

button.invia {
  background-color: inherit;
  border: none;
  text-align: left;
  font-size: 16px;
  color: #fff;

  img {
    margin-left: 10px;
    transition: all 0.2s linear;
  }

  &:hover {
    img {
      margin-left: 15px;
    }
  }

  &.disabled {
    color: #878787;
    cursor: initial;
  }
}

input.form-control,
textarea.form-control {
  border-radius: 0;
  background-color: inherit;
  color: #fff;

  &::placeholder {
    color: #fff;
    font-weight: 400;
  }

  &:focus {
    border-color: var(--greenb2b);
    box-shadow: 0 0 0 0.2rem rgba(166, 249, 52, 0.25);
  }

  &.invalid {
    border-color: var(--red);
    box-shadow: 0 0 0 0.2rem rgba(255, 35, 61, 0.25);
  }
}

small {
  color: var(--red);

  &.file-error {
    margin-left: -30px;
    margin-right: 20px;
  }
}

.invia {
  width: 342px;
}

section {
  padding-top: 93px;

  form {
    margin-top: 62px;
  }
}

// .contact-us{

//   .form-control {
//     border-radius: 0;
//     border: 1px solid #fff;
//     background-color: transparent;
//     color: #fff;
//     &:focus {
//       color: #fff;
//       background-color: unset;
//       border-color: var(--green);
//       box-shadow: 0 0 0 0.2rem rgb(166 249 52 / 25%);
//     }
//   }
// }
.suggestions {
  .sub {
    margin-top: 22px;
  }

  .my-buttons {
    flex-direction: column;

    .form-group {
      margin: 0;
      margin-right: 0;

      .allegato-btn {
        min-width: 243px;
        margin: 0;

        &.my-btn-transparent.invalid {
          border-color: var(--red);
          box-shadow: 0 0 0 0.2rem rgba(255, 35, 61, 0.25);
          color: var(--red);
        }

        img {
          margin-right: 20px;
        }
      }

      .loaded {
        width: 163.11px;
      }
    }

    .invia {
      margin-top: 25px;
    }
  }
}

.recapiti {
  padding-left: 80px;
  padding-top: 90px;

  p {
    margin-bottom: 26px;

    &:last-of-type {
      margin-top: 76px;
    }
  }
}

h3 {
  margin-bottom: 42px;
}

.icons {
  width: 166px;

  .icon {
    color: #26262a;
    padding: 14px;
    background-color: #fff;
    border-radius: 50%;
    font-size: 20px;

    &:hover {
      cursor: pointer;
      text-decoration: none;
    }
  }
}

@media screen and (min-width: 768px) {
  #forms {
    .suggestions {
      .my-buttons {
        flex-direction: row;

        .form-group {
          margin: 0;
          margin-right: 41px;

          .allegato-btn {
            min-width: 243px;
            margin: 0;

            img {
              margin-right: 20px;
            }
          }

          .loaded {
            width: 163.11px;
          }
        }

        .invia {
          margin-top: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  .recapiti {
    padding-left: 166px;
  }
}
</style>

